import { FormControl, Grid, Typography } from '@mui/material';
import styles from '../ServicesMenu/services.module.scss'
import { CustomMenuItem, CustomSelect } from '../common/StyledComponents/StyledFields';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useState } from 'react';
import CONSTANTS from "../../config/constants.json";

const YoungAdultGallery = () => {
    const [selectedYear, setSelectedYear] = useState(2021);

    const handleYearChange = (event: any) => {
        setSelectedYear(event.target.value);
    };

    const renderSelectedYear = () => {
        switch (selectedYear) {
            case 2021:
                return youngadults2021();
            case 2019:
                return youngadults2019();
            case 2018:
                return youngadults2018();
            case 2018_09:
                return youngadult2018Oct();
            default:
                return null;
        }
    };

    const galleryyear = (): React.ReactElement => {
        return (
            <FormControl sx={{ paddingBottom: '24px', width: '100px', height: "50px" }}>
                <CustomSelect
                    sx={{ color: '#000', border: "1px solid red" }}
                    IconComponent={KeyboardArrowDownIcon}
                    defaultValue={2021}
                    id="grouped-select"
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                border: '1px solid #F05802',
                                '& ul': {
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    overflowY: 'auto',
                                    minHeight: 'auto',
                                    maxHeight: '300px',
                                    '&::-webkit-scrollbar': {
                                        width: '8px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#F3C539',
                                        borderRadius: '6px',
                                    },
                                },
                            },
                        },
                    }}
                >
                    <CustomMenuItem value={2017}>2017</CustomMenuItem>
                    <CustomMenuItem value={2018}>2018</CustomMenuItem>
                    <CustomMenuItem value={2019}>2019</CustomMenuItem>
                    <CustomMenuItem value={2020}>2020</CustomMenuItem>
                    <CustomMenuItem value={2021}>2021</CustomMenuItem>
                </CustomSelect>
            </FormControl>
        );
    };
    const youngadults2021 = (): React.ReactElement => {
        return (
            <>
                <Grid className={styles.mainContainer}>
                    <Grid className={styles.cardContainer}>
                        <div className={styles.alignitems}>
                            <Grid >
                                <img src='/images/socaleventimage_one.png' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/socialeventimage_two.png' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/socialeventimage_three.png' className={styles.imagesize} />
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </>
        )
    }

    const youngadults2019 = (): React.ReactElement => {
        return (
            <>
                <Grid className={styles.mainContainer}>
                    <Grid className={styles.cardContainer}>
                        <div className={styles.alignitems}>
                            <Grid >
                                <img src='/images/youngadult12-21-2019.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadul2019.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019imge.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019images.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019images3.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadultimage4.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image5.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image6.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image7.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image8.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image9.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image10.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image11.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2019image12.jpg' className={styles.imagesize} />
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </>
        )
    }

    const youngadults2018 = (): React.ReactElement => {
        return (
            <>
                <Grid className={styles.mainContainer}>
                    <div className={styles.cardContainer}>
                        <div className={styles.alignitems}>
                            <Grid xs={6} item>
                                <img src='/images/youngadult2018image1.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image2.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image3.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image4.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image5.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image6.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image7.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image8.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image9.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image10.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image11.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image12.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image13.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image14.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image15.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image16.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image17.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image18.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image19.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image20.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image21.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid >
                                <img src='/images/youngadult2018image22.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018image23.jpg' className={styles.imagesize} />
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </>
        )
    }
    const youngadult2018Oct = (): React.ReactElement => {
        return (
            <>
                <Grid className={styles.mainContainer}>
                    <Grid className={styles.cardContainer}>
                        <div className={styles.alignitems}>
                            <Grid >
                                <img src='/images/youngadult2018octimage.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018octimage2.jpg' className={styles.imagesize} />
                            </Grid>
                            <Grid>
                                <img src='/images/youngadult2018octimage3.jpg' className={styles.imagesize} />
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </>
        )
    }
    return (
        <div className={styles.YoungadultGalleryLayout}>
            <Grid>
                {/* <Grid sx={{ display: "flex", width: "100%" }}>
                    <Typography className={styles.headeractivites}>
                        <span className={styles.texthighlight}>Photos</span> {"  "} |{"  "}
                        <span>Videos</span>{"  "} | {"  "}
                        <span> <a href= {CONSTANTS.DOMAIN_URL+"/hints/youngadults/images/temple-brochure.pdf"}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none", color: "#882E14" }}>Brochure
                        </a></span>
                    </Typography>
                  
                </Grid> */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* <Typography className={styles.header} >Young Adults' Social Event</Typography> */}
                    <Grid sx={{marginRight:"30px"}} >
                        {/* <FormControl sx={{ paddingBottom: '24px', width: '100px', height: "50px" }}>
                            <Grid sx={{ display: "flex", gap: "5px" }}>
                                <Typography className={styles.yeartext}>Year</Typography>
                                <CustomSelect
                                    sx={{ color: '#000', border: "1px solid red", width: "100%" }}
                                    IconComponent={KeyboardArrowDownIcon}
                                    defaultValue={selectedYear}
                                    id="grouped-select"
                                    onChange={handleYearChange}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                border: "1px solid #F05802",
                                                "& ul": {
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    overflowY: "auto",
                                                    minHeight: "auto",
                                                    maxHeight: "300px",
                                                    "&::-webkit-scrollbar": {
                                                        width: "8px",
                                                    },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        background: "#F3C539",
                                                        borderRadius: "6px",
                                                    },
                                                },
                                            },
                                        },
                                    }}
                                >
                                    <CustomMenuItem value={2021}>2021</CustomMenuItem>
                                    <CustomMenuItem value={2019}>2019</CustomMenuItem>
                                    <CustomMenuItem value={2018}>2018</CustomMenuItem>
                                    <CustomMenuItem value={2018_09}>2018-Oct</CustomMenuItem>
                                </CustomSelect>
                            </Grid>
                        </FormControl> */}
                        <Typography sx={{color:"#000"}} ><b> &lt;&lt; SITE IS UNDER DEVELOPMENT &gt;&gt;</b></Typography>
                    </Grid>
                </div>
            </Grid>
            {/* {renderSelectedYear()} */}
        </div>
        
    )
}
export default YoungAdultGallery;